export default "__VITE_ASSET__Btx60XEa__"